import { useState } from 'react';
import { useTeamsQuery } from '@common/cache';
import { useTeamTableStore } from '../Filters/filters.store';
import { useDrawerStore } from 'store/drawer.store.ts';

export const useTeam = () => {
  const { filters } = useTeamTableStore();
  const [selectedTeamId, setSelectedTeamId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = { count: 0, teams: [] },
    isRefetching,
    isFetching,
  } = useTeamsQuery(filters);

  const entries = data.teams;

  const handleClose = () => {
    setDrawerOpen(false);
    setSelectedTeamId('');
  };

  const handleOpenTeamDetails = (id: string) => {
    setDrawerOpen(true);
    setSelectedTeamId(id);
  };

  return {
    entries,
    totalCount: data.count,
    isInitialFilters:
      filters.search === '' && filters.state === '' && filters.record_id === '',
    isDrawerOpen,
    selectedTeamId,
    handleClose,
    handleOpenTeamDetails,
    isLoading: isRefetching || isFetching,
  };
};
